import { SWAN_STYLE_KEY_MAP } from '@vp/swan';

export const swanStyleKeys = [
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.standardHero,
];
